import { MessageChannelsToIds, SupportedMessageFormats, SDQuery_Types } from "../../contracts";
import { STR_ERRORS } from "../../Strings";
import { SDQuerySubscribersStore } from "../../Stores";
const formats = {
    [SupportedMessageFormats["jsonrpc2.0"]]: (channel, data, id) => {
        return {
            jsonrpc: "2.0",
            params: data,
            method: channel,
            id: id || MessageChannelsToIds[channel]
        };
    }
};
export function RequestFormatter(type, channel, data, id) {
    return JSON.stringify(formats[type](channel, data, id));
}
export function SDQRequestFormatter(query) {
    const id = SDQuerySubscribersStore.getQueryID(query);
    let message = "";
    if (query.name === SDQuery_Types.Unsubscribe) {
        message = RequestFormatter(SupportedMessageFormats["jsonrpc2.0"], query.name, {}, query.params.id);
    }
    else {
        if (typeof id === "undefined") {
            throw new Error(STR_ERRORS.SDQRequestFormatRequiresActiveQuery);
        }
        message = RequestFormatter(SupportedMessageFormats["jsonrpc2.0"], query.name, query.params, id);
    }
    return message;
}
//# sourceMappingURL=RequestFormatter.js.map